export default import.meta.ROLLUP_FILE_URL_W5bkrX$7ByP5XhrXdGkoCg;